import Axios from "../../api/Axios";
const BASE_URL = "SalesReport/";
export const Endpoint = {
    GetGSTToExcel : "GetGSTToExcel"
};
// /api/SalesReport/GetGSTToExcel
export const createAPIEndpointGst = () => {
    return {get:(Endpoint)=>Axios.get(BASE_URL+Endpoint)};
};